import {
  acceptRequest,
  addRequest,
  deleteRequest,
  parseRequestDoc,
  rejectRequest,
} from '@db/Requests/Common';
import { getCurrentUserId } from '@helpers/firebase/Auth';
import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { RequestStatus, RequestType } from '@types';

export async function addFollow(userId: string) {
  const currentUserId = getCurrentUserId();
  return await addRequest({
    userId: currentUserId,
    entityId: userId,
    type: RequestType.FOLLOW_USER,
  });
}

export async function acceptFollow(userId: string) {
  const currentUserId = getCurrentUserId();
  return await acceptRequest({
    userId,
    entityId: currentUserId,
    type: RequestType.FOLLOW_USER,
  });
}

export async function rejectFollow(userId: string) {
  const currentUserId = getCurrentUserId();
  return await rejectRequest({
    userId,
    entityId: currentUserId,
    type: RequestType.FOLLOW_USER,
  });
}

export async function deleteFollow(userId: string) {
  const currentUserId = getCurrentUserId();
  return await deleteRequest({
    userId: currentUserId,
    entityId: userId,
    type: RequestType.FOLLOW_USER,
  });
}

export function listenToFollowUserRequestUserIds(
  status: RequestStatus,
  onSnapshot: (userIds: Set<string>) => void,
  onError: (error: db.FirestoreError) => void
) {
  const currentUserId = getCurrentUserId();
  const query = db.query(
    db.collection(firestore, 'requests'),
    db.where('userId', '==', currentUserId),
    db.where('type', '==', RequestType.FOLLOW_USER),
    db.where('status', '==', status)
  );

  return db.onSnapshot(
    query,
    (snapshot) => {
      const entityIds = snapshot.docs.map((doc) => parseRequestDoc(doc).entityId);
      onSnapshot(new Set(entityIds));
    },
    onError
  );
}

export function listenToAcceptedFollowUserRequestUserIds(
  onSnapshot: (userIds: Set<string>) => void,
  onError: (error: db.FirestoreError) => void
) {
  return listenToFollowUserRequestUserIds(RequestStatus.ACCEPTED, onSnapshot, onError);
}

export function listenToPendingFollowUserRequestUserIds(
  onSnapshot: (userIds: Set<string>) => void,
  onError: (error: db.FirestoreError) => void
) {
  return listenToFollowUserRequestUserIds(RequestStatus.PENDING, onSnapshot, onError);
}

export async function getFollowing(userId: string) {
  const query = db.query(
    db.collection(firestore, 'requests'),
    db.where('userId', '==', userId),
    db.where('type', '==', RequestType.FOLLOW_USER),
    db.where('status', '==', RequestStatus.ACCEPTED)
  );
  const snapshot = await db.getDocs(query);
  return snapshot.docs.map((doc) => parseRequestDoc(doc).entityId);
}

export async function getFollowers(userId: string) {
  const query = db.query(
    db.collection(firestore, 'requests'),
    db.where('entityId', '==', userId),
    db.where('type', '==', RequestType.FOLLOW_USER),
    db.where('status', '==', RequestStatus.ACCEPTED)
  );
  const snapshot = await db.getDocs(query);
  return snapshot.docs.map((doc) => parseRequestDoc(doc).userId);
}
